import Service from '../service'

/**
 * @type {LocalStorage}
 */
export default class LocalStorage extends Service {
    /**
     * 
     * @param {Object} options
     */
    constructor (options = {}) {
        super(options)
        this.storageKey = 'fac_'
    }

    /**
     * Recebe uma chave com o prefixo fac_ e busca-a no localStorage
     *
     * @param {String|Number} key
     * @param {*} value
     * @returns 
     */
    get(key) {
        return localStorage.getItem(this.storageKey + key)
    }

    /**
     * Recebe uma chave e valor e seta-os no localStorage com o prefixo fac_
     *
     * @param {String|Number} key
     * @param {*} value
     * @returns 
     */
    set(key, value) {
        localStorage.setItem(this.storageKey + key, value)
    }

    /**
     * Recebe uma chave com o prefixo fac_ e remove-a do localStorage
     *
     * @param {String|Number} key
     * @param {*} value
     * @returns 
     */
    remove(key) {
        localStorage.removeItem(this.storageKey + key)
    }

    /**
     * Recebe uma chave sem o prefixo fac_ e busca-a no localStorage
     *
     * @param {String|Number} key
     * @param {*} value
     * @returns 
     */
    getLegacy(key) {
        return localStorage.getItem(key)
    }

    /**
     * Recebe uma chave e valor e seta-os no localStorage sem o prefixo fac_
     *
     * @param {String|Number} key
     * @param {*} value
     * @returns 
     */
    setLegacy(key, value) {
        return localStorage.setItem(key, value)
    }

    /**
     * Recebe uma chave sem o prefixo fac_ e remove-a do localStorage
     *
     * @param {String|Number} key
     * @param {*} value
     * @returns 
     */
    removeLegacy(key) {
        return localStorage.removeItem(key)
    }

    /**
     * Limpa todos os dados do localStorage
     */
    clear() {
        return localStorage.clear()
    }
}
